module.exports = __webpack_public_path__ + "img/IMG_1094.a79623e8.jpeg";